import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAnalytics } from '../hooks/useAnalytics';

const AnalyticsPageTracker: React.FC = () => {
  const location = useLocation();
  const { trackPageView } = useAnalytics();

  useEffect(() => {
    // Get page title from document or generate from path
    const pageTitle = document.title || getPageTitleFromPath(location.pathname);
    
    // Track page view
    trackPageView(pageTitle, globalThis.location.href);
  }, [location, trackPageView]);

  return null;
};

// Helper function to generate page titles from paths
const getPageTitleFromPath = (pathname: string): string => {
  const segments = pathname.split('/').filter(Boolean);
  
  if (segments.length === 0) return 'Home';
  if (segments[0] === 'login') return 'Login';
  if (segments[0] === 'create-group') return 'Create Group';
  if (segments[0] === 'group-selection') return 'Group Selection';
  
  // Group-based pages
  if (segments.length >= 2) {
    const groupSlug = segments[0];
    const page = segments[1];
    
    switch (page) {
      case 'dashboard': return `Dashboard - ${groupSlug}`;
      case 'my-lists': return `My Lists - ${groupSlug}`;
      case 'browse-lists': return `Browse Lists - ${groupSlug}`;
      case 'my-reservations': return `My Reservations - ${groupSlug}`;
      case 'admin': return `Admin - ${groupSlug}`;
      default: return `${page} - ${groupSlug}`;
    }
  }
  
  return pathname;
};

export default AnalyticsPageTracker;